import { UseFormReturn } from "react-hook-form";
import { StorageType } from "../../../../types/external-storage/StorageType";
import StorageForm from "../update-credentials/StorageForm";
import {
  AzureConfigureRequest,
  azureSchema,
} from "../../../../api/externalStorage";
import { FormField } from "../FormField";
import { useTranslation } from "react-i18next";
import { useCreateExternalStorage } from "../../../../hooks/useExternalStorage";

type ConfigureAzureProps = {
  id: string;
  siteId: string;
  storageType: StorageType.AzureBlob;
  setIsOpen: (isOpen: boolean) => void;
};

export default function ConfigureAzureBlobPrincipalForm({
  id,
  siteId,
  storageType,
  setIsOpen,
}: ConfigureAzureProps) {
  const { t } = useTranslation("configureStorage");
  const mutationHook = useCreateExternalStorage;

  interface FormFieldsProps {
    formState: UseFormReturn<AzureConfigureRequest>["formState"];
    register: UseFormReturn<AzureConfigureRequest>["register"];
  }

  const FormFields = ({ register, formState }: FormFieldsProps) => {
    return (
      <>
        <FormField
          label={t("configureStorage:tenantId")}
          name={"AzureBlob.TenantId"}
          register={register}
          formState={formState}
          required
        />
        <FormField
          label={t("configureStorage:clientId")}
          name={"AzureBlob.ClientId"}
          register={register}
          formState={formState}
          required
        />
        <FormField
          label={t("configureStorage:clientSecret")}
          name={"AzureBlob.ClientSecret"}
          register={register}
          formState={formState}
          type="password"
          required
        />
        <FormField
          label={t("configureStorage:containerName")}
          name={"AzureBlob.ContainerName"}
          register={register}
          formState={formState}
          required
        />
        <FormField
          label={t("configureStorage:storageAccountName")}
          name={"AzureBlob.StorageAccountName"}
          register={register}
          formState={formState}
          required
        />
        <FormField
          label={t("configureStorage:azurePrefix")}
          name={"AzureBlob.AzurePrefix"}
          register={register}
          formState={formState}
        />
      </>
    );
  };

  return (
    <StorageForm
      id={id}
      siteId={siteId}
      setIsOpen={setIsOpen}
      schema={azureSchema}
      mutationHook={mutationHook}
      requestProcessor={(data) => data}
      options={{
        defaultValues: {
          SiteId: siteId,
          StorageType: storageType,
          AzureBlob: {
            TenantId: "",
            ClientId: "",
            ClientSecret: "",
            ContainerName: "",
            StorageAccountName: "",
          },
        },
      }}
    >
      {(form) => {
        const { register, formState } = form;
        return <FormFields register={register} formState={formState} />;
      }}
    </StorageForm>
  );
}
